/*
const selectsAll = document.querySelectorAll(".crosssell-container .wrapper-dropdown");

selectsAll.forEach(select => {
  const optionsContainer = select.children[2];
  const optionsList = select.querySelectorAll("div.wrapper-dropdown li");

  
  const crossProduct = select.closest('.crosssell_product');
  const productJson = JSON.parse(crossProduct.querySelector('[type="application/json"]').textContent);

  for (let o of optionsList) {
    o.addEventListener("click", (e) => {
      e.preventDefault();
      if (select.classList.contains("updateTitle")) {
        select.querySelector(".selected-display").innerHTML = o.children[0].innerHTML;
      }

      if(crossProduct.classList.contains('variants')){
        let option1 = selectsAll[0].querySelector(
          ".selected-display"
        ).innerHTML;
        let option2 = selectsAll[1].querySelector(
          ".selected-display"
        ).innerHTML;
        let option3 = null;
        
        let variant = findCrossVariant(productJson, option1, option2, option3);
        console.log("option1: " + option1 + ", option2: " + option2 + ", option3: " + option3);
        console.log("Valid: " + variant.id);
  
        crossProduct.querySelector("input").setAttribute('variant_id', variant.id);
        if(variant.featured_image != null){
          crossProduct.querySelector("img").src = variant.featured_image.src;
        }
        o.closest('.dropdown').querySelector("li[selected]").removeAttribute("selected");
        o.setAttribute("selected", "");
  
        crossProduct.querySelectorAll(".price > span:last-child").forEach((priceDiv) => {
          priceDiv.innerHTML = Shopify.formatMoney(variant.price, '{{ amount_with_comma_separator }}€');
        });

        rebuildCrossOptions(crossProduct, productJson, option1, option2, option3);
      }
    });
    
  }
});
*/

/*
window.addEventListener("click", function (e) {
  let select = e.target.closest(".wrapper-dropdown");
  if (select == null) {
    closeAllDropdowns();
  } else if (select.classList.contains("active")) {
    e.preventDefault();
    closeAllDropdowns();
  } else {
    e.preventDefault();
    let currentActive = document.querySelector(".wrapper-dropdown.active");
    let arrow = select.children[1];

    if (currentActive) {
      handleDropdown(currentActive, false);
    }

    handleDropdown(select, true);
  }
});
*/

// close all the dropdowns
/*
function closeAllDropdowns() {
  selectsAll.forEach((selected) => {
    const optionsContainer = selected.children[2];
    let arrow = selected.children[1];
    handleDropdown(selected, false);
  });
}
*/

// open all the dropdowns
/*
function handleDropdown(dropdown, open) {
  let arrow = dropdown.querySelector("svg.arrow");
  if (open) {
    arrow.classList.add("rotated");
    dropdown.classList.add("active");
  } else {
    arrow.classList.remove("rotated");
    dropdown.classList.remove("active");
  }
}
*/

function findCrossVariant(productJson, option1, option2, option3) {
  for (let i = 0; i < productJson.length; i++) {
    if (
      productJson[i].option1 == option1 &&
      productJson[i].option2 == option2 &&
      productJson[i].option3 == option3
    ) {
      return productJson[i];
    }
  }
  return "null";
}

function rebuildCrossOptions(crossProduct, productJson, option1, option2, option3) {
  const fieldsets = Array.from(crossProduct.querySelectorAll(".wrapper-dropdown"));
  for (let optionLevel = 0, n = fieldsets.length; optionLevel < n; optionLevel++) {
    const inputs = fieldsets[optionLevel].querySelectorAll("li.item");
    let possibleVariant;
    inputs.forEach((input) => {
      if(optionLevel == 0){
        possibleVariant = findCrossVariant(productJson, input.getAttribute("value"), option2, option3);
      }else if(optionLevel == 1){
        possibleVariant = findCrossVariant(productJson, option1, input.getAttribute("value"), option3);
      }else if(optionLevel == 2){
        possibleVariant = findCrossVariant(productJson, option1, option2, input.getAttribute("value"));
      }
      
      if(possibleVariant == "null"){
        input.setAttribute("disabled", "true");
      }else{
        input.removeAttribute("disabled");
      }
      
    });
  }
}

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "{{amount}}€";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
